import { inject, Injectable } from '@angular/core'
import { FirestoreService } from '../../shared/modules/fire/firestore.service'
import { Notification } from '../../../../domain/notification.model'
import { AuthService } from '../../modules/auth/auth.service'
import { Observable, switchMap } from 'rxjs'
import { FirestoreQueryConstraintsBuilder } from '../../shared/modules/fire/firestore/list/firestore-query-constraints-builder'
import { FirestoreFilter } from '../../shared/modules/fire/firestore/list/firestore-filter'
import { map } from 'rxjs/operators'

@Injectable({ providedIn: 'root' })
export class NotificationsFirestoreService extends FirestoreService<Notification> {
	protected readonly authService = inject<AuthService>(AuthService)

	constructor() {
		super()
	}

	getNewNotificationsCount(): Observable<number> {
		return this.authService.appUserChanges$.pipe(
			map((user) => {
				const lastCheck = user?.lastCheck ?? new Date().toISOString()
				return FirestoreQueryConstraintsBuilder.withFilters([
					FirestoreFilter.greaterThan('createdAt', lastCheck),
				]).build()
			}),
			switchMap((fireQuery) => this.read(fireQuery).pipe(map((notifications) => notifications.length))),
		)
	}

	addNotification(data: string) {
		let notification = new Notification()
		notification.data = `${data} a fost actualizat`
		this.add({ ...notification } as Notification)
	}

	protected resolvePath(): string {
		return 'notifications'
	}
}
